import Game from "../../Game.js";
import BasicAI from "./ai/BasicAI.js";
import Mob from "./Mob.js";
import StandardSheetAnimations from "./StandardSheetAnimations.js";

export default class Slime extends Mob {
	constructor(sprites, infoable = true) {
		super(sprites, StandardSheetAnimations.getAnimation("slime"), Slime.WALK_STEP * Game.MULT, Slime.RADIUS);
		this.width = Game.ENEMY_WIDTH;
		this.height = Game.ENEMY_HEIGHT;
		this.substAnimation("parry_w", 1, { row:3, col: 0 });


		let traits = {
			clas: "enemy",
			race: "slime",
			openDoors: false,
			static: false,
			qi: BasicAI.QI_LOW,
			speed: Slime.WALK_STEP * Game.MULT,
			radius: Slime.RADIUS,
			runspeed: Slime.RUN_STEP * Game.MULT,
			timeWarns: Slime.TIME_WARNS,
			infoable: infoable
		}
		this.setMobTraits(traits)

	}
	init() {
		this.mc = jQuery("#template-mob").clone();
		this.mc.attr("id", "mob" + Mob.ENUM++);
		this.mc.css({
			width: this.width,
			height: this.height,
		});

		this.initSprites();

	}

}
Slime.RADIUS = 4;
Slime.WALK_STEP = 2;
Slime.RUN_STEP = 3;
Slime.TIME_WARNS = [250, 350];